import { FamilyInviteStatus } from './family.model';
import { HelfSettings } from './client-types';
import { Photo } from './global.model';

export enum ResidentGender {
  Male = 'Male',
  Female = 'Female',
  Other = 'Other',
}

/** @deprecated */
export interface Resident {
  id: string;
  facilityId: string;
  preferenceId: string;
  firstName: string;
  lastName: string;
  preferredName?: string;
  roomNumber: string;
  program?: string[];
  deleted?: boolean;
  data?: Array<ResidentData>;
  familyStatus?: {
    status: FamilyInviteStatus
    dateUpdated?: number;
  }[];
  lastActive?: number;
  // HELF resident override, when not set the facility HELF settings apply
  helf?: HelfSettings;
}

export type ResidentData = {
  approved: boolean;
  approver?: string;
  dateApproved?: number;
  dateCreated: number;
  firstName: string;
  lastName: string;
  preferredName?: string;
};

export interface ConversationStarter {
  id: string;
  type: 'CONVERSATION_STARTER' | 'LIFESTORY',
  title: string;
  body: string;
  source: 'AI' | 'FAMILY',
  dateCreated: number;
}


export interface ResidentPreferenceDataRaw {
  id: string;
  conversationStarters?: ResPrefConversationStarters[];
  cultureValuesBelieves?: ResPrefCultureValuesBelieves[];
  hobbiesInterestsSports?: ResPrefHobbiesInterestsSports[];
  languageCountry?: ResPrefLanguageCountry[];
  notes?: ResPrefNotes[];
  music?: ResPrefMusic[];
  occupationsLife?: ResPrefOccupationsLife[];
  peoplePets?: ResPrefPeoplePets[];
  profile?: ResPrefProfile[];
}
export type residentPreferenceDataTopics = ResPrefNotes | ResPrefConversationStarters | ResPrefCultureValuesBelieves | ResPrefHobbiesInterestsSports | ResPrefLanguageCountry | ResPrefMusic | ResPrefOccupationsLife | ResPrefPeoplePets | ResPrefProfile;
/** @deprecated Use ResidentPreferenceData from client-types instead. */
export interface ResidentPreferenceData {
  id: string;
  conversationStarters?: ResPrefConversationStarters;
  notes?: ResPrefNotes;
  cultureValuesBelieves?: ResPrefCultureValuesBelieves;
  hobbiesInterestsSports?: ResPrefHobbiesInterestsSports;
  languageCountry?: ResPrefLanguageCountry;
  music?: ResPrefMusic;
  occupationsLife?: ResPrefOccupationsLife;
  peoplePets?: ResPrefPeoplePets;
  profile?: ResPrefProfile;
}

export type ResPrefConversationStarters = {
  conversationStarters?: string[];
  approved?: boolean;
  dateApproved?: number;
  dateCreated?: number;
};

export type ResPrefNotes = {
  notes?: string[];
  approved?: boolean;
  dateApproved?: number;
  dateCreated?: number;
};

export type ResPrefCultureValuesBelieves = {
  communityGroups?: string[];
  culturalBackground?: string;
  personalIdentity?: boolean;
  practiceReligion?: boolean;
  religion?: string;
  suggestedReligion?: string[];
  approved?: boolean;
  dateApproved?: number;
  dateCreated?: number;
};

export type ResPrefHobbiesInterestsSports = {
  hobbiesInterests?: string[];
  hobbiesMemories?: string;
  sports?: string[];
  sportsMemories?: string;
  suggestedSports?: string[];
  approved?: boolean;
  dateApproved?: number;
  dateCreated?: number;
};

export type ResPrefLanguageCountry = {
  countryGrewUp?: string;
  countryOfBirth?: string;
  countryOtherPlaces?: string;
  primaryLanguage?: string;
  secondaryLanguage?: string;
  approved?: boolean;
  dateApproved?: number;
  dateCreated?: number;
};

export type ResPrefMusic = {
  favouriteArtists?: string[];
  genres?: string[];
  memories?: string;
  suggestedArtists?: string[];
  approved?: boolean;
  dateApproved?: number;
  dateCreated?: number;
};

export type ResPrefOccupationsLife = {
  achievements?: string[];
  industries?: string[];
  memories?: string;
  suggestedOccupations?: string[];
  approved?: boolean;
  dateApproved?: number;
  dateCreated?: number;
};

export type ResPrefPeoplePets = {
  animals?: string[];
  importantPeople?: ImporantPerson[];
  pets?: string[];
  petsMemories?: string;
  approved?: boolean;
  dateApproved?: number;
  dateCreated?: number;
};

export type ImporantPerson = {
  name?: string;
  relationship?: string;
};

export type ResPrefProfile = {
  yob?: string;
  gender?: string;
  approved?: boolean;
  dateApproved?: number;
  dateCreated?: number;
};

export interface ResidentContent {
  id: string;
  headerTitle: string;
  headerIcon: string;
  headerBgColor: string;
  rows: ResidentContentRow[];
  memory?: string;
  edit?: boolean;
  slug?: string;
}

export interface ResidentContentRow {
  thumbnail?: string;
  heading: string;
  title: string;
  type: string;
  link: string;
}


export interface SuggestedContentCollection {
  [key: string]: ResidentContent;
}

export interface ResidentPhoto  extends Photo {
  residentId: string;
}

export interface PhotoResizeOutput {
  size: number;
  width: number;
  height: number;
  format: string;
  hasThumbnail: boolean;
}

//  ************** END INTERFACES and TYPES ***********

// if we have to many enums and const, maybe move to Schema file

export const residentFields = `
  id
  facilityId
  preferenceId
  data {
    firstName
    lastName
    preferredName
    approved
    dateCreated
    dateApproved
    approver
  }
  firstName
  lastName
  preferredName
  roomNumber
  dateCreated
  deleted
  program
  familyStatus {
    status
    dateUpdated
  }
  helf {
    sleepModeStart
    sleepModeEnd
    sleepModeDisabled
  }
`;

export const preferenceFields = `
  id
  profile {
    approved
    dateCreated
    gender
    yob
  }
  music {
    approved
    dateCreated
    genres
    favouriteArtists
    suggestedArtists
    memories
  }
  occupationsLife {
    approved
    dateCreated
    industries
    suggestedOccupations
    memories
    achievements
  }
  languageCountry {
    approved
    dateCreated
    primaryLanguage
    secondaryLanguage
    countryOfBirth
    countryGrewUp
    countryOtherPlaces
  }
  cultureValuesBelieves {
    approved
    dateCreated
    religion
    suggestedReligion
    practiceReligion
    culturalBackground
    personalIdentity
    communityGroups
  }
  peoplePets {
    approved
    dateCreated
    pets
    animals
    petsMemories
    importantPeople {
      name
      relationship
    }
  }
  hobbiesInterestsSports {
    approved
    dateCreated
    hobbiesInterests
    hobbiesMemories
    sports
    suggestedSports
    sportsMemories
  }
  conversationStarters {
    approved
    dateCreated
    conversationStarters
  }
  notes {
    approved
    dateCreated
    notes
  }
`;